import { Component, OnInit, Inject, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-historico-facturas',
  templateUrl: './historico-facturas.component.html',
  styleUrls: ['./historico-facturas.component.scss']
})
export class HistoricoFacturasComponent implements OnInit, AfterViewInit, OnDestroy {

  // Variables DataTable //
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   */
  constructor(@Inject(MAT_DIALOG_DATA) private _data, private _cartera: CarteraService) {
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.dtOptions = {
      scrollY: '383px',
      language: {
        lengthMenu: `Número de _MENU_ registros por página`,
        zeroRecords: `Datos no encontrados - Lo sentimos`,
        info: `Mostrando la página _PAGE_ de _PAGES_`,
        infoEmpty: `No hay registros disponibles`,
        infoFiltered: `(Filtrado de _MAX_ registros totales)`,
        LoadingRecords: `Cargando...`,
        search: `Buscar:`,
        paginate: {
          first:   `Primero`,
          last:    `Último`,
          next:    `Siguiente`,
          previous:`Anterior`
        }
      },
      order: [ 2, 'desc'],
      columns: [
        {
          title: 'N° Factura',
          data:  'NoFactura'
        },
        {
          title: 'Nombre',
          data:  'nombre_factura'
        },
        {
          title: 'Fecha',
          data:  'fecha_factura'
        },
        {
          title: 'N° Beneficiarios',
          data:  'numero_beneficiarios'
        },
        {
          title: 'Valor Unitario',
          data:  'valor_unitario'
        },
        {
          title: 'Valor Total',
          data:  'valor_total'
        },
        {
          title: 'Saldo Anterior',
          data:  'saldo_anterior'
        },
        {
          title: 'Nuevo Saldo',
          data:  'nuevo_saldo'
        }
      ]
    }
    
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this._cartera.VerHistoricoFacturasxGrupo(this._data.base_datos, this._data.grunit, this._data.grugru).subscribe((data: any) => {
      this.tableOpt = data;
      this.renderer();
    });
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Renderiza la tabla
   */
  renderer(): void{
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    })
  }

}



